import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", d: "M22 12.0195C22 6.50953 17.51 2.01953 12 2.01953C6.49 2.01953 2 6.49953 2 12.0195C2 17.5395 6.49 22.0195 12 22.0195C12.93 22.0195 13.83 21.8795 14.68 21.6395L14.23 19.6895C13.52 19.8995 12.77 20.0095 12 20.0095C7.59 20.0095 4 16.4195 4 12.0095C4 7.59953 7.59 4.00953 12 4.00953C16.41 4.00953 20 7.59953 20 12.0095C20 12.8195 19.87 13.5895 19.64 14.3295C19.38 15.1695 18.59 15.7595 17.7 15.7595C16.58 15.7595 15.66 14.8495 15.66 13.7795C15.66 13.7795 15.68 13.4595 15.79 12.8895C15.86 12.5595 15.92 12.2395 15.98 11.9495L16.77 7.75953L16.21 7.39953C14.86 6.51953 12.61 5.96953 10.64 6.68953C9.37 7.15953 7.66 8.36953 6.75 11.4795C6.25 13.1895 6.47 14.8595 7.37 16.0695C8.19 17.1595 9.48 17.7695 11 17.7695C12.68 17.7695 13.76 17.0895 14.48 16.1395C15.22 17.1195 16.38 17.7695 17.7 17.7695C19.46 17.7695 21.03 16.6095 21.55 14.9295H21.56C21.85 14.0095 22 13.0295 22 12.0195ZM11 15.7595C10.11 15.7595 9.41 15.4495 8.97 14.8695C8.45 14.1795 8.34 13.1495 8.66 12.0495C9.21 10.1895 10.11 9.01953 11.33 8.56953C11.75 8.40953 12.18 8.34953 12.59 8.34953C13.33 8.34953 14.03 8.54953 14.54 8.76953L14.01 11.5695C13.41 14.7895 12.71 15.7595 11 15.7595Z" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconAt = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconAt.displayName = "IconAt";

export { IconAt };
